import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MigrateSipDomainComponent } from "@onsip/web/features/administrators/pbx-settings/migrate-sip-domain/migrate-sip-domain.component";
import { MigrateSipDomainRoutingModule } from "@onsip/web/features/administrators/pbx-settings/migrate-sip-domain/migrate-sip-domain-routing.module";
import { TranslateModule } from "@ngx-translate/core";
import { MatButtonModule } from "@angular/material/button";
import { ReactiveFormsModule } from "@angular/forms";
import { MatRadioModule } from "@angular/material/radio";
import { SipAddressFieldModule } from "@onsip/web/features/shared/components/sipAddressField/sip-address-field.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { RouterModule } from "@angular/router";
import { MigrateSipDomainEditComponent } from "./migrate-sip-domain-edit/migrate-sip-domain-edit.component";
import { MigrateSipDomainViewComponent } from "./migrate-sip-domain-view/migrate-sip-domain-view.component";
import { LoadingContainerComponent } from "@onsip/web/features/shared/components/loadingContainer/loading-container.component";

@NgModule({
  declarations: [
    MigrateSipDomainComponent,
    MigrateSipDomainEditComponent,
    MigrateSipDomainViewComponent
  ],
  imports: [
    CommonModule,
    MigrateSipDomainRoutingModule,
    TranslateModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatRadioModule,
    SipAddressFieldModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    RouterModule,
    LoadingContainerComponent
  ]
})
export class MigrateSipDomainModule {}
